import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getUsers } from "../../redux/actions/Users";
import UsersFilter from "./UsersFilter";
import UserPage from "../UserPage/UserPage";

class UsersPage extends React.Component {
  state = {
    name: ""
  };

  componentWillMount() {
    this.props.getUsers();
  }

  getFilteredUsers() {
    return this.props.users.filter(user =>
      user.name.toLowerCase().includes(this.state.name.toLowerCase())
    );
  }

  render() {
    return (
      <div>
        <h1>Users</h1>
        <UsersFilter
          onChange={e => {
            this.setState({
              [e.target.name]: e.target.value
            });
          }}
        />
        <table className="table table-sm table-responsive-md">
          <thead>
            <tr>
              <th>Name</th>
              <th>Username</th>
              <th>Last logged in</th>
            </tr>
          </thead>
          <tbody>
            {this.getFilteredUsers().map((user, key) => (
              <tr key={key}>
                <td>
                  <Link to={"/user/" + user.id}>{user.name}</Link>
                </td>
                <td>{user.username}</td>
                <td>{UserPage.renderLatestSession(user)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = ({ users }) => ({ users });

const mapDispatchToProps = dispatch => {
  return {
    getUsers: () => {
      return dispatch(getUsers());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);



// WEBPACK FOOTER //
// ./src/containers/UsersPage/UsersPage.js